import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSAvaibookStore = GenericCollectionFactory("PMS-AVAIBOOK-INTEGRATION", "id");